import React, { useEffect, useState } from 'react';
import { Icon } from 'react-icons-kit'
import { ic_add_box } from 'react-icons-kit/md/ic_add_box'
import { ic_search } from 'react-icons-kit/md/ic_search'
import { ic_delete } from 'react-icons-kit/md/ic_delete'
import Swal from 'sweetalert2'
import withReactContent from 'sweetalert2-react-content'

import NavBar from '../components/NavBar'
import FrTable from '../components/FrTable'
import FrSelect from '../components/FrSelect'
import UserOptions from '../components/UserOptions'
import FrLoading from '../components/FrLoading'
import FooterDelphus from '../components/FooterDelphus'
import FrDatePicker from '../components/FrDatePicker'
import Dialog from '@material-ui/core/Dialog';
import { colors } from '../utils/vars'
import FrTextInput from '../components/FrTextInput'
import Checkbox from '@material-ui/core/Checkbox'
import FormControlLabel from '@material-ui/core/FormControlLabel';


import api from '../services/api'
import { paramsToObject, formToObject, populateForm, objectToQueryString, isEmpty, getSedeCode, getUserCode } from '../utils/functions'

import './styles/DefaultMainScreen.css';
import './styles/Manut.css';

const swal = withReactContent(Swal)

function Cartoes(props) {
  const [data, setData] = useState([])
  const [filter, setFilter] = useState({})
  const [filtered, setFiltered] = useState(false)
  const [enableAdd, setenableAdd] = useState('N')
  const [enableEdit, setenableEdit] = useState('N')
  const [enableDel, setenableDel] = useState('N')
  const [comboUsu, setComboUsu] = useState([{ value: '', display: '' }])
  const [showModal, setShowModal] = useState(false)
  const [data_inicial, setData_Inicial] = useState('')
  const [data_final, setData_Final] = useState('')
  const [comboFpg, setComboFpg] = useState([{ value: '', display: '' }])
  const [selected, setSelected] = useState([])


  const columns = [
    { id: 'data_geracao', date: true, numeric: false, label: 'Data Geração', align: 'left', minWidth: 50 },
    { id: 'nomeusu', numeric: false, label: 'Usuário', align: 'left', minWidth: 100 },
    { id: 'data_inicial', date: true, numeric: false, label: 'Data Inicial', align: 'left', minWidth: 50 },
    { id: 'data_final', date: true, numeric: false, label: 'Data Final', align: 'left', minWidth: 50 },
    { id: 'total_registros', numeric: false, label: 'Total Registros', align: 'left', minWidth: 50 },
  ]

  useEffect(() => {
    const fetchData = async () => {
      swal.fire({
        html: <FrLoading text="Carregando..." />,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false
      })

      let tela = 'Cobrança Débito Conta'
      setenableAdd(await api.getAcessos(tela, 'Inclusao'))
      setenableEdit(await api.getAcessos(tela, 'Alteracao'))
      setenableDel(await api.getAcessos(tela, 'Exclusao'))

      setComboUsu(await api.getComboData('usuarios'))
      let fpg = await api.getComboDataWhere('formas_pagamento', "?fk_tpf=1")
      setComboFpg(fpg)

    

      const urlParams = new URLSearchParams(window.location.search);
      let query = paramsToObject(urlParams)

      setFilter(query)
      populateForm(document.getElementById('searchForm'), query)

      swal.close()
      if (query.buscar === 'true') {
        let event = new Event('build');
        getData(event)
      }
    }

    fetchData()
  }, [])

  function getData(e) {
    e.preventDefault()
    var formData = new FormData(document.getElementById('searchForm'))
    var queryObject = formToObject(formData)
    if (!isEmpty(queryObject)) {
      queryObject.buscar = true
      setFiltered(true)
      window.history.replaceState({ filtered: true }, 'filter', "/salute/cartoes?" + objectToQueryString(queryObject));
      swal.fire({
        html: <FrLoading text="Buscando dados..." />,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false
      })
      api.get('/controle_cobranca', { params: queryObject }).then(r => {
        setData(r.data)
        swal.close()
      })
    } else {
      swal.fire({
        title: 'Nenhum filtro informado!',
        html: '<p>Informe ao menos um filtro para realizar a busca.',
        icon: 'warning'
      })

    }
  }

  function clearForm(e) {
    e.preventDefault();
    window.history.replaceState({ filtered: false }, 'filter', '/salute/cartoes');
    document.getElementById('searchForm').reset()
    setFilter({})
  }

  function geraCobranca(e) {
    e.preventDefault();
    setData_Inicial('')
    setData_Final('')
    setShowModal(true)
  }

  function confirmaModal(e) {
    e.preventDefault();
    
 

    // alert(fk_fpg.length)
    if ((data_inicial) && (data_final)) {
      api.post('/controle_cobranca/geraCartao?fk_usu=' + getUserCode() + '&data_inicial=' + data_inicial + '&data_final=' + data_final ).then(r => {
        if (r.status === 200) {
          swal.fire({
            customClass: {
              container: 'my-swal'
            },

            title: `<h2 style='color: ${colors.info900}'>Arquivo gerado!<h2>`,
            html: `<p style='color: ${colors.info900}'>Arquivo gerado com sucesso!</p>`,
            icon: 'success',
          }).then((result) => {
            if (result.value) {
              setShowModal(false)
              const auxValues = { ...filter };
              auxValues.data_inicial = new Date()
              auxValues.data_final = new Date()
              setFilter(auxValues);

              window.location.reload()
            }
          })
        }
      })
    } else
      swal.fire({
        customClass: {
          container: 'my-swal'
        },

        title: 'Informe as datas e os bancos a gerar!',
        html: '<p>Informe o período de vencimento e os bancos a gerar!',
        icon: 'warning'
      })

  }

  function fechaModal(e) {
    e.preventDefault();
    setShowModal(false)
  }

  const handleChange = (e) => {
    
    const auxValues = { ...filter };
    switch (e.target.name) {
      case 'data_inicial': setData_Inicial(e.target.value);
        break;

      case 'data_final': setData_Final(e.target.value);
        break;
      default:
        auxValues[e.target.name] = e.target.value;
    }
    setFilter(auxValues);
  };


  return (
    <div className="Manut">
      <NavBar />
      <div className="ManutContent">
        <div className="defaultHeader">
          <h3>Cobrança Cartões</h3>
          <UserOptions temaEscuro={props.temaEscuro} setTemaEscuro={props.setTemaEscuro} />
        </div>
        <br />
        <div className="filtersDiv">
          <form id="searchForm" onSubmit={getData}>
            <div>
              <FrSelect
                value={filter.fk_usu || -1}
                style={{ width: 210 }}
                name="fk_usu"
                id="fk_usu"
                label='Usuário'
                data={comboUsu}
                onChange={handleChange}
                mostraTodos
              />

              <FrDatePicker
                value={(filter.dataini || '').split('T')[0]}
                name="dataini"
                id="dataini"
                color="#49573B"
                label="Período Geração"
                variant="outlined"
                size="small"
                style={{ width: 190 }}
                onChange={handleChange}
              />

              <label style={{ paddingRight: '7px', paddingTop: '7px' }}>a</label>

              <FrDatePicker
                value={(filter.datafim || '').split('T')[0]}
                name="datafim"
                id="datafim"
                color="#49573B"
                variant="outlined"
                size="small"
                style={{ width: 190 }}
                onChange={handleChange}
              />

              <FrSelect
                value={filter.fk_tpf || 1}
                style={{ width: 250 }}
                name="fk_tpf"
                id="fk_tpf"
                label='Banco/Conta'
                data={comboFpg}
                onChange={handleChange}
                mostraTodos
                hidden
              />

            </div>
            <div>
              <button onClick={getData}>
                <Icon icon={ic_search} size={18} />
                Pesquisar
              </button>
              <button onClick={clearForm}>
                <Icon icon={ic_delete} size={18} />
                Limpar
              </button>
              {enableAdd !== 'S' ? '' :
                <button style={{ width: '200px' }} onClick={geraCobranca}>
                  <Icon icon={ic_add_box} size={18} />
                  Gerar Cartões
                </button>
              }

            </div>
          </form>
        </div>
        <br />

        <div>
          <Dialog aria-labelledby="simple-dialog-title" open={showModal} maxWidth={'lg'}>
            <div className="modalContent">

              <FrDatePicker
                value={(data_inicial || '').split('T')[0]}
                name="data_inicial"
                id="data_inicial"
                color="#49573B"
                label="Período Vencimento"
                variant="outlined"
                size="small"
                style={{ width: 190 }}
                onChange={handleChange}
                autoFocus
              />

              <label style={{ paddingRight: '7px', paddingTop: '7px' }}>a</label>

              <FrDatePicker
                value={(data_final || '').split('T')[0]}
                name="data_final"
                id="data_final"
                color="#49573B"
                variant="outlined"
                size="small"
                style={{ width: 190 }}
                onChange={handleChange}
              />

              <br />

            </div>

            <div className="FrModalFooter">
              <div className="FrModalButtonsDiv">
                <button onClick={confirmaModal}> Confirmar </button>
                <button onClick={fechaModal}> Sair </button>
              </div>
            </div>

          </Dialog>
        </div>


        <div className={"tableDiv" + (props.frame && data.length > 0 ? '-frame' : '')}>
          <FrTable 
            startOrderBy={'data_geracao'} 
            debito_conta 
            width={50} 
            regName="debito_conta" 
            frame={props.frame} 
            columns={columns} 
            searched={filtered} 
            codeName="pk_ccb" 
            page={'debito_conta'} 
            data={data} 
            selected={selected}
            setSelected={setSelected}
          />

        </div>
        <FooterDelphus />
      </div>
    </div>
  );
}

export default Cartoes;